import React from 'react'

export default function Image(props) {
    return (
        <img alt="INSTAR IP Cameras" src={props.src} width="100%" height="100%"/>
    )
}
